import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { PicListTabsLoading } from "./PicListTabsLoading/PicListTabsLoading";

type propsType = {
  data?: any;
};

export const PicListTabs = ({ data }: propsType) => {
  const globalStateUser = useSelector((state: RootState) => {
    return state.userData;
  });
  const [isLoading, setIsLoading] = useState(false);
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(
        (process.env.REACT_APP_VOX_TABS_DETAIL as string) + `/${data}/pic-list`,
        {
          headers: {
            Authorization: `Bearer ${globalStateUser.token}`,
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        setDataTable(res.data.data);
      })
      .catch((error) => {
        setIsLoading(true);
        console.log(error);
      });
  }, []);

  return (
    <div>
      {isLoading ? (
        <PicListTabsLoading />
      ) : (
        <div className="overflow-x-auto border border-slate-200 rounded-md">
          <table className="table w-full">
            {/* head */}
            <thead>
              <tr>
                <th />
                <th>PIC ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Number</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.length === 0 ? (
                <tr>
                  <th></th>
                  <td></td>
                  <td>No Data</td>
                  <td></td>
                  <td></td>
                </tr>
              ) : (
                dataTable.map((data: any, idx: any) => {
                  return (
                    <tr key={idx}>
                      <th />
                      <td>{data?.pic_id}</td>
                      <td>{data?.full_name}</td>
                      <td>{data?.email}</td>
                      <td>{data?.primary_number}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
